import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RoomFacade } from "./facades";

@NgModule({
  imports: [CommonModule],
  providers: [RoomFacade]
})
export class RoomStoreModule {}
